
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'
    import { buildLocalization } from '@/util'

    import MyIcon from '@/components/common/my-icon.vue'

    import { IMaterialDTO, MaterialListItem } from '@/types/material'

    export default defineComponent({
        name: 'docIcon',

        components: {
            MyIcon
        },

        props: {
            materialData: { type: Object as PropType<IMaterialDTO | MaterialListItem>, required: true },
            size: { type: Number as PropType<number>, required: false, default: () => 16 },
            fillSpace: { type: Boolean as PropType<boolean>, required: false, default: () => false },
            icon: { type: String as PropType<string>, required: false, default: () => 'pdf' },
            color: { type: String as PropType<string>, required: false, default: () => 'red' }
        },

        setup(props) {
            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = {}

            /********************************************************************************************************************
             COMPUTED PROPERTIES
             ********************************************************************************************************************/
            const docCount = computed(() => (props.materialData.documents?.filter(doc => doc.documentType != 'RES'))?.length ?? 0)
            const docInfoText = computed(() => docCount.value > 1
                ? `${docCount.value} ${localize('documents')}`
                : `${docCount.value} ${localize('document')}`
            )

            const computedData = { docCount, docInfoText }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            const publicMethods = { localize }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
